import { IBodyGetCostsQueryParams } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyCosts/getBodyCostsQuery.type';
import { getBodyCostsQueryFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyCosts/getBodyCostsQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getBodyCostsQueryOptions = (params: IBodyGetCostsQueryParams) => {
  return queryOptions({
    queryKey: ['body-costs', params],
    queryFn: () => getBodyCostsQueryFunction(params),
  });
};
